import React from 'react';
import {
  BodyDark,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  TableSection,
  Loading,
  Checkbox,
} from '@/components/elements';
import { FeFile } from './types';
import { useContextMenu } from './useContextMenu';
import { Icon } from '@roc-digital/ui-web';

export interface FilesTableProps {
  files: FeFile[];
  onSelectFiles?(file: FeFile): void;
  selectedFile?: FeFile;
  select?: boolean;
  loading?: boolean;
  onAction?: (action: 'rename' | 'archive' | 'delete', fe: FeFile) => void;
}

export function FilesTable(props: FilesTableProps) {

  const hasActions = !props.select;
  const ctxFileRef = React.useRef<FeFile>(null)
  const ctxMenu = useContextMenu({
    onAction: (action) => {
      if(props.onAction && ctxFileRef.current) {
        props.onAction(action, ctxFileRef.current)
      }
    }
  });

  const openCtxMenu = React.useCallback((event: any, file: FeFile) => {
    //@ts-ignore
    ctxFileRef.current = file;
    ctxMenu.open(event);
  }, [])

  return (
    <div className='flex flex-col gap-4 h-full'>
      <Table>
        <TableSection type="head">
          <TableRow>
            {props.select ? <>
              <TableHeader className={'w-[24px]'}>-</TableHeader>
            </> : <></>}
            <TableHeader className={''}>Image</TableHeader>
            <TableHeader className={'w-full'}>Name</TableHeader>
            <TableHeader className={'min-w-[185px]'}>Created</TableHeader>
            {hasActions ? <>
              <TableHeader className={'text-right w-[32px]'}>Actions</TableHeader>
            </> : <></>}
          </TableRow>
        </TableSection>
        <TableSection>
          {!props.loading ? props.files.map((file) => (
            renderRow(file, hasActions, props, openCtxMenu)
          )) : null}
          {props.loading ? (
            <TableRow>
              <TableCell className={'text-center'} colSpan={6}>
                <Loading size={'medium'} />
              </TableCell>
            </TableRow>
          ) : null}
          {!props.loading && !props.files?.length && props.files?.length > 0 ? (
            <>
              <TableRow>
                <TableCell className={'text-center'} colSpan={6}>
                  This query returned no results.
                </TableCell>
              </TableRow>
            </>
          ) : null}
        </TableSection>
      </Table>
      {ctxMenu.jsx}
    </div>
  );
}

function renderRow(file: FeFile, hasActions: boolean | undefined, props: FilesTableProps, openCtx: (event: any, item: any) => void) {
  return <tr key={file.id} className="'border-b border-stone-200 text-left text-font text-xs h-2 hover:bg-slate-50' h-[100px]"
    style={{borderBottom: '1px solid #e7e5e4'}}
    onClick={() => {
      if(props.onSelectFiles) {
        props.onSelectFiles(file)
      }
    }}
  >
    {props.select ? <>
      <td className={'w-[32px]'}>
        <Checkbox value={file.id === props.selectedFile?.id}/>
      </td>
    </> : <></>}
    <TableCell className={''}>
      <img src={file.src} style={{maxHeight: 100, maxWidth: 200}}/>
    </TableCell>
    <TableCell className={''}>
      <BodyDark>{props.select ? file.name : <a href={`/images/${file.id}`} target="_blank">{file.name}</a>}</BodyDark>
    </TableCell>
    <TableCell className={``}>
      <BodyDark className={`${hasActions ? '' : 'text-xs'}`}>{formateDate(file.created)}</BodyDark>
    </TableCell>
    {hasActions ? <>
      <TableCell className={'text-right'}>
        <span onClick={(event) => openCtx(event, file)} className='cursor-pointer'>
          <Icon src={icon} size='medium'/>
        </span>
      </TableCell>
    </> : <></>}
  </tr>
}

const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="gray" viewBox="0 0 256 256"><path d="M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28,28,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28,28,0,0,0,128,180Z"></path></svg>`

function formateDate(date?: number) {
  if(!date) return '';
  return new Date(date * 1000).toLocaleString();
}